/**
 * Calculate distance between two coordinates
 * https://stackoverflow.com/a/21623206
 * @param {number} lat1
 * @param {number} lng1
 * @param {number} lat2
 * @param {number} lng2
 * @return {number}
 */
const calcDistance = (lat1, lng1, lat2, lng2) => {
  const p = Math.PI / 180
  const R = 12742 // 2 * R, R = 6371 km, the radius of the earth
  const c = Math.cos

  const a = 0.5 - c((lat2 - lat1) * p)/2 + c(lat1 * p) * c(lat2 * p) * (1 - c((lng2 - lng1) * p)) / 2

  return R * Math.asin(Math.sqrt(a))
}

export default calcDistance
